import dayjsLib from "dayjs"
import utc from "dayjs/plugin/utc"
import duration from "dayjs/plugin/duration"

dayjsLib.extend(utc)
dayjsLib.extend(duration)

export const dayjs = dayjsLib
